import { radioAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(radioAnatomy.keys);

export const Radio = defineMultiStyleConfig({
	baseStyle: {
		control: {
			bgColor: 'bg.surface',
			borderColor: 'border.default',
			borderRadius: 'full',
			borderStyle: 'solid',
			borderWidth: '1px',
			boxSize: 5,
			cursor: 'pointer',
			_checked: {
				bgColor: 'bg.surface',
				_before: {
					bg: 'primary.bg',
					borderRadius: 'full',
					content: '""',
					display: 'block',
					h: 3.5,
					w: 3.5,
				},
				_disabled: {
					_before: {
						bg: 'text.disabled',
					},
				},
				_hover: {
					bgColor: 'bg.surface',
				},
			},
			_disabled: {
				bgColor: 'bg.surface',
				borderColor: 'border.default',
			},
			_hover: {
				bgColor: 'bg.surface',
			},
		},
		label: {
			ml: 2,
			_groupDisabled: {
				color: 'text.disabled',
			},
		},
		container: {},
	},
});
